import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-footer-column',
  templateUrl: './table-footer-column.component.html',
  styleUrls: ['./table-footer-column.component.scss']
})
export class TableFooterColumnComponent implements OnInit {

  @Input() name;
  @Input() size = 'medium';
  @Input() styleType: 'old' | null;
  @HostBinding('class.align-right') @Input() alignRight;
  @HostBinding('className') className: string;

  constructor() { }

  ngOnInit(): void {
    this.className = [this.name, this.size, this.styleType].join(' ');
  }

}
